/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const typeSchema = z.enum(['text'])

export type TypeSchema = z.infer<typeof typeSchema>
